'use client';

import classNames from '@sindresorhus/class-names';
import {useEnvConfig} from '@web-catalog/env';
import React from 'react';

import {YandexBannerAd} from '@web-catalog/components/Ads';
import {CategoriesList} from '@web-catalog/components/CategoriesList';

import {
  useCategories,
  useIsGamesPage,
  useOmicronABFlag,
} from '@web-catalog/hooks';
import useMediaQueryMatch from '@web-catalog/hooks/useMediaQueryMatch';

import styles from './AsideMenu.module.scss';

export const AsideMenu: React.FC = () => {
  const isGamesPage = useIsGamesPage();
  const {categories, activeCategory} = useCategories(isGamesPage);
  const currentCategory = activeCategory?.category || '';
  const adBannerEnabled = useOmicronABFlag(
    'WEB_YANDEX_AD_LEFT_SIDEBAR_ENABLED',
  );
  const {YANDEX_ADS_LEFT_SIDEBAR_BANNER_ID} = useEnvConfig();
  const breakpointMatch = useMediaQueryMatch('(min-width: 1280px)');

  return (
    <div className={styles.menu}>
      <div
        className={classNames(styles.menubox, adBannerEnabled && styles.withAd)}
      >
        <CategoriesList
          categories={categories}
          activeCategory={currentCategory}
          isGamesPage={isGamesPage}
        />
        {adBannerEnabled && breakpointMatch && (
          <YandexBannerAd
            bannerContainerClassName={styles.adPlaceholder}
            blockId={YANDEX_ADS_LEFT_SIDEBAR_BANNER_ID}
            additionalId="left-sidebar"
            adType="sd_banner_side"
          />
        )}
      </div>
    </div>
  );
};
